import React from "react";

import { Box, Divider, Stack, Typography } from "@mui/material";

import { TimeKeeperMetricType } from "./types";

interface TeamsListRow {
  inPolicy?: boolean;
  isAverage?: boolean;
  metric: TimeKeeperMetricType;
  propertyToSortBy: string;
  team: any;
  withDivider: boolean;
}

const TeamsListRow = ({
  inPolicy,
  isAverage = false,
  metric,
  propertyToSortBy,
  team,
  withDivider,
}: TeamsListRow) => {
  return (
    <React.Fragment>
      {withDivider && <Divider />}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={1}
        sx={{
          p: 1,
          bgcolor: team.id === "AVERAGE" ? "shades.ghost.300" : undefined,
        }}
      >
        <Typography
          variant="bodySecondaryReg"
          sx={{
            width: "70%",
            color:
              team.id === "AVERAGE"
                ? "shades.primary.500"
                : "shades.neutral.500",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            fontWeight: isAverage ? 500 : 400,
          }}
        >
          {team.name}
        </Typography>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="end"
          spacing={1}
          sx={{ width: "30%" }}
        >
          <Box
            sx={{
              borderRadius: "50%",
              bgcolor:
                team.id === "AVERAGE"
                  ? "shades.primary.500"
                  : inPolicy
                    ? "scores.positive"
                    : "scores.negative",
              height: "8px",
              width: "8px",
            }}
          />
          <Typography
            variant="bodySecondaryReg"
            sx={{
              color:
                team.id === "AVERAGE"
                  ? "shades.primary.500"
                  : "shades.neutral.500",
              fontWeight: isAverage ? 500 : 400,
            }}
          >
            {Math.round(team[propertyToSortBy])}
            {metric === "time" ? " min" : "%"}
          </Typography>
        </Stack>
      </Stack>
    </React.Fragment>
  );
};

export default TeamsListRow;
